<template>
  <div class="container">
    <h1 class="heading">Past Years</h1>
    <p class="mb-5">
      A look back at the galas and recitals that brought us here. Each year lives on
      as its own page&mdash;revisit a favorite performance or relive a special memory.
    </p>

    <h2 class="heading">Senior Galas</h2>
    <div class="row mb-5">
      <div v-for="show in galas" :key="show.url" class="col-12 col-sm-6 col-lg-4 mb-4">
        <div class="card h-100">
          <div class="card-body d-flex flex-column text-center">
            <h3 class="heading mb-1">{{ show.year }}</h3>
            <p v-if="show.theme" class="font-italic mb-3">&ldquo;{{ show.theme }}&rdquo;</p>
            <a
              :href="show.url"
              target="_blank"
              rel="noopener"
              class="btn btn-primary mt-auto"
            >Visit Site</a>
          </div>
        </div>
      </div>
    </div>

    <h2 class="heading">Recitals</h2>
    <div class="row mb-5">
      <div v-for="show in recitals" :key="show.url" class="col-12 col-sm-6 col-lg-4 mb-4">
        <div class="card h-100">
          <div class="card-body d-flex flex-column text-center">
            <h3 class="heading mb-1">{{ show.year }}</h3>
            <p v-if="show.theme" class="font-italic mb-3">&ldquo;{{ show.theme }}&rdquo;</p>
            <a
              :href="show.url"
              target="_blank"
              rel="noopener"
              class="btn btn-primary mt-auto"
            >Visit Site</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PastYears",
  data() {
    return {
      galas: [
        { year: 2025, theme: "One More Time", url: "https://cvpa-gala-2025.classcitizen.com" },
        { year: 2024, theme: "The Best Is Yet To Come!", url: "https://cvpa-gala-2024.classcitizen.com" },
        { year: 2023, theme: "Celebrate", url: "https://cvpa-gala-2023.classcitizen.com" }
      ],
      recitals: [
        { year: 2025, theme: "Feel the Joy", url: "https://cvpa-recital-2025.classcitizen.com" },
        { year: 2024, theme: "Fired Up", url: "https://cvpa-recital-2024.classcitizen.com" },
        { year: 2023, theme: "Slay the Night", url: "https://cvpa-recital-2023.classcitizen.com" },
        { year: 2022, theme: "Brand New", url: "https://cvpa-recital-2022.classcitizen.com" },
        { year: 2021, theme: "Together Again", url: "https://cvpa-recital-2021.classcitizen.com" }
      ]
    };
  }
};
</script>
